import { style } from 'typestyle'
import { CSSProperties } from 'typestyle/lib/types'
import prop from 'vue-strict-prop'
import { componentFactoryOf, modifiers as m } from 'vue-tsx-support'

import DropdownMenu from '@/components/semantic-ui/DropdownMenu'

import { List } from '@/datastore/models'

import grocery from '@/store/modules/grocery'

interface Events {
	onDelete(list: List): void
}

export default componentFactoryOf<Events>().create({
	name: 'ListSidebarItem',
	props: {
		list: prop.ofType<List>().required,
	},
	data() {
		return {
			isRenaming: false,
			isSaving: false,
			newName: '',
		}
	},
	computed: {
		overflowMenuStyle(): CSSProperties {
			return {
				display: (this.isRenaming || this.isSaving) ? 'none' : 'block',
			}
		},
	},
	methods: {
		enterRenameMode(): void {
			this.newName = this.list.name
			this.isRenaming = true
			setTimeout(() => {
				const el = this.$refs['name-input'] as HTMLInputElement
				el.focus()
				el.setSelectionRange(0, el.value.length)
			})
		},
		async setName(): Promise<void> {
			const { list, newName } = this

			this.isRenaming = false

			if (list.name === newName) {
				return
			}

			this.isSaving = true
			await grocery.updateList({ listId: list.$id, name: newName })
			this.isSaving = false
		},
	},
	render() {
		return (
			<router-link class="link item" to={{ name: 'pantry', params: { id: this.list.$id }, query: { page: '0' } }}>
				<div class={styleItem}>
					{!this.isRenaming ?
						<div>
							{this.list.name}
						</div>
						:
						<div class="ui mini inverted transparent input">
							<input
								onBlur={this.setName}
								onKeyup={m.enter(this.setName)}
								ref="name-input"
								type="text"
								v-model={this.newName}
								/>
						</div>
					}
					<DropdownMenu class="right pointing" style={this.overflowMenuStyle}>
						<i class="ellipsis vertical link icon" />
						<div class="menu">
							<div class="item" onClick={m.prevent(this.enterRenameMode)}>
								<i class="pencil icon"></i>
								Rename
							</div>
							<div class="item" onClick={m.prevent(() => this.$emit('delete', this.list))}>
								<i class="trash icon" />
								Delete
							</div>
						</div>
					</DropdownMenu>
				</div>
			</router-link>
		)
	},
})

const styleItem = style({
	display: 'flex',
	justifyContent: 'space-between',
})
